import { Injectable } from '@angular/core';
import {
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateChild
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '@core/services/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class LicenceGuard implements CanActivateChild {
  constructor(private router: Router, public authorizationService: AuthorizationService) {}

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const LicencedProps = this.authorizationService.GetProperties_ModuleLicence() || [];
    return LicencedProps.length > 0 ? true : false;
  }
}
